<app-content>
  @if (!uiSettings()?.mobileEmbed) {
    <app-breadcrumbs>
      <li>
        <a routerLink='/wnioski-robocze' aria-label='Wnioski robocze'>
          Wnioski robocze
        </a>
      </li>
      <li>
        {{ serviceType()?.name || 'Ładowanie danych...' }}
      </li>
    </app-breadcrumbs>
  }
  <section>
    @if (!uiSettings()?.application?.hideTitle) {
      <h2>
        {{ serviceType()?.name || '' }}
      </h2>
    }
    <router-outlet></router-outlet>
    @if (!uiSettings()?.mobileEmbed) {
      <div [innerHTML]="serviceType()?.editorFooterContent"></div>
    }
  </section>
</app-content>
